import profileService from '../../services/profile';

export default {
  state: {
    user: {},
  },
  getters: {
    user: state => state.user,
  },
  actions: {
    getUser({ commit }) {
      return new Promise((resolve, reject) => {
        profileService.getUser()
          .then((response) => {
            commit('set_user', response.data);
            resolve();
          })
          .catch(() => {
            reject();
          });
      });
    },
  },
  mutations: {
    set_user(state, user) {
      state.user = user;
    },
  },
};
